import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const AnalyzeYourExpensesQuestion = () => {
  return (
    <React.Fragment>
      <MetaControlField attr={'questionTitle'} />
      <MetaControlField attr={'answer'} />
    </React.Fragment>
  );
};

AnalyzeYourExpensesQuestion.defaultProps = {
};

AnalyzeYourExpensesQuestion.propTypes = {
};
